import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-full flex flex-row overflow-x-auto" }

import Filter from '@/interfaces/Filter';
import { useFilter } from '@/store/filter';
import { closeCircle } from 'ionicons/icons';

import { IonIcon, IonChip, IonLabel } from '@ionic/vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ActiveFilterChipLayout',
  emits: ["filterChanged"],
  setup(__props, { emit }: { emit: ({
  (event: "filterChanged", value: void): void,
}), expose: any, slots: any, attrs: any }) {

const filterStore = useFilter()



function deactivateOneFilter(filter: Filter) {
  filterStore.deactivateFilter(filter)
  emit("filterChanged")
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterStore).activeFilters, (filter, index) => {
      return (_openBlock(), _createBlock(_unref(IonChip), {
        key: index,
        onClick: ($event: any) => (deactivateOneFilter(filter)),
        class: "first:ml-0 last:mr-0 min-w-min"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLabel), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(filter.titel), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(IonIcon), { icon: _unref(closeCircle) }, null, 8, ["icon"])
        ]),
        _: 2
      }, 1032, ["onClick"]))
    }), 128))
  ], 512)), [
    [_vShow, _unref(filterStore).activeFilters.length > 0]
  ])
}
}

})